import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {EMPTY_LOT} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-widget-detail-lots',
    templateUrl: './detail-lots.component.html',
    styleUrls: ['./detail-lots.component.scss']
})
export class DetailLotsComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public dialog: MatDialog,
        public commonService: CommonService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.favorite = this.adService.updateValues(this.favorite);
    }

    edit(event, fields = '') {
        if (this.favorite.lots.length === 1) {
            this.favorite.square = this.favorite.lots[0].square;
        }

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    addLot() {
        let lot = Object.assign({}, EMPTY_LOT);
        lot.estate_type = 'Appartement';
        this.favorite.lots.push(lot);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    duplicateLot(i) {
        let lot = Object.assign({}, this.favorite.lots[i]);
        this.favorite.lots.push(lot);
        this.favoriteChange.emit();
    }

    deleteLot(i) {
        this.favorite.lots.splice(i, 1);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }
}
